<template>
  <v-col :cols="block.cols" :xs="block.colsxs" :sm="block.colssm" :md="block.colsmd" :lg="block.colslg" :xl="block.colsxl" :offset="block.offset" class="d-flex align-start">
    <v-text-field
      :value="form"
      :dense="true"
      filled
      :label="block.label"
      :disabled="block.disabled"
      hide-details="auto"
      :class="block.inputClass"
      placeholder=" "
      @input="$emit('update:form', $event)"
    />
  </v-col>
</template>

<script>
export default {
   name: 'TextField',
   model: {
      prop: 'form',
      event: 'update:form'
   },

   props: {
      block: {
         type: Object,
         required: true,
      },
      form: {
         type: String,
         default: () => '',
      },
   },
}
</script>
<style>
   /* .v-text-field .v-label {
      transform: translateY(-18px) scale(0.75);
      background-color: white;
   } */
</style>
